<script>
    import Spinner from 'svelte-spinner';

    import { isDateInPast, isToday, isDateInFuture } from '../../../date-time.js';
  
    import TriggerDate from './TriggerDate.svelte';

    export let triggerDates;

    $: previousTriggerDates = !(triggerDates) ? null : triggerDates.filter(triggerDate => {
        if (isDateInPast(triggerDate.annualDate)) {
            return true;
        }
    });

    $: upcomingTriggerDates = !(triggerDates) ? null : triggerDates.filter(triggerDate => {
        if (isDateInFuture(triggerDate.annualDate) || isToday(triggerDate.annualDate)) {
            return true;
        }
    });
</script>


<style>
    .trigger-dates-widget {
        display: flex;
        flex-direction: column;
    }

    .divider {
        border-top: 1px dashed #0267B3;
        margin-bottom: 4px
    }
</style>

<div class="trigger-dates-widget">
    {#if triggerDates}
        {#if previousTriggerDates}
            {#each previousTriggerDates as triggerDate, i}
                <TriggerDate date={triggerDate.date} type={triggerDate.displayType} notes={triggerDate.notes}
                    annualDate={triggerDate.annualDate} previous={triggerDate.previous} id={`td-list-previous-${i}`} />
            {/each}
        {/if}

        {#if (previousTriggerDates && previousTriggerDates.length > 0) 
                && (upcomingTriggerDates && upcomingTriggerDates.length > 0)}
            <div class="divider" />
        {/if}

        {#if upcomingTriggerDates}
            {#each upcomingTriggerDates as triggerDate, i}
                <TriggerDate date={triggerDate.date} type={triggerDate.displayType} notes={triggerDate.notes}
                    annualDate={triggerDate.annualDate} upcoming={triggerDate.upcoming} id={`td-list-upcoming-${i}`} />
            {/each}
        {/if}
    {:else}
        <div class="widget-spinner">
            <Spinner size="100" speed="750" color="#3d5980" thickness="3" gap="15" />
        </div>
    {/if}
</div>